import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { formatKr } from "@/lib/format";
import { cn } from "@/lib/utils";

export const KpiCard = ({ statusKey, label, icon: Icon, count, sum, to, index = 0 }) => (
  <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.28, delay: index * 0.04, ease: [0.2, 0.8, 0.2, 1] }}>
    <Link
      to={to}
      data-testid={`kpi-card-${statusKey}`}
      className={cn("group block rounded-xl border bg-card p-4 card-lift focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", count === 0 && "opacity-80")}
    >
      <div className="flex items-center gap-2">
        <span className={cn("h-7 w-7 rounded-md flex items-center justify-center shrink-0", `kpi-icon-${statusKey}`)}>
          <Icon style={{ width: 15, height: 15 }} />
        </span>
        <p className="text-sm font-medium text-muted-foreground truncate">{label}</p>
      </div>
      <p className="mt-3 font-heading text-3xl font-semibold tnum leading-none">{count}</p>
      <p className="mt-1.5 text-xs text-muted-foreground tnum">{count === 0 ? "Ingen" : formatKr(sum)}</p>
    </Link>
  </motion.div>
);
